function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import CustomerLocaleKeys from '../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchProductLineOfBusinessDeliveryCapability } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import { CurrentCustomerSelector } from 'invision-core/src/components/customer/customer.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import * as ContentActivitySelectors from '../../../reducers/selectors/customer.content.activity.selectors';
import { CurrentCustomerIdSelector, RouteParams } from '../../../reducers/selectors/customer.selectors';
import * as ContentActivityActions from '../../../reducers/actions/customer.content.activity.actions';
import { getProductMetadata } from '../../../reducers/actions/products.actions';
import { DETAIL_STATE_OR_NAME as PRODUCT_DETAILS_PAGE_REDIRECT } from '../products/products.config';
import { ProductMetadataByIdSelector } from 'invision-core/src/components/metadata/products/products.selectors';
var REMOVABLE = false;
var PAGINATION_SLOTS = 0;
var ContentActivityController = /*#__PURE__*/function () {
  function ContentActivityController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ContentActivityController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ContentActivityController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          activeIsSelected: ContentActivitySelectors.ActiveIsSelectedSelector(store),
          activeItemCount: ContentActivitySelectors.ActiveItemCountSelector(store),
          allContentActivity: ContentActivitySelectors.AllContentActivityCollectionSelector(store),
          backBannerText: ContentActivitySelectors.BackBannerTextSelector(store),
          customerContentActivity: ContentActivitySelectors.CustomerContentActivityCollectionSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentListHasContentActivity: ContentActivitySelectors.CurrentListHasContentActivitySelector(store),
          currentPage: ContentActivitySelectors.CurrentPageSelector(store),
          deviceFilterText: ContentActivitySelectors.DeviceFilterTextSelector(store),
          deviceId: ContentActivitySelectors.DeviceIdRouteParamSelector(store),
          deviceName: ContentActivitySelectors.DeviceNameRouteParamSelector(store),
          emptyStateGlyph: ContentActivitySelectors.EmptyStateGlyphSelector(store),
          emptyStateMessage: ContentActivitySelectors.EmptyStateMessageSelector(store),
          errorMessage: ContentActivitySelectors.ContentActivityErrorSelector(store),
          hasActiveContentActivity: ContentActivitySelectors.HasActiveContentActivitySelector(store),
          hasAnyContentActivity: ContentActivitySelectors.HasAnyContentActivitySelector(store),
          hasFilteredContentActivity: ContentActivitySelectors.HasFilteredContentActivitySelector(store),
          hasLoadedContentActivity: ContentActivitySelectors.HasLoadedContentActivitySelector(store),
          isFetchingContentActivity: ContentActivitySelectors.IsFetchingContentActivitySelector(store),
          isLoadingContentActivity: ContentActivitySelectors.IsLoadingContentActivitySelector(store),
          isLoadingDetails: ContentActivitySelectors.IsLoadingDetails(store),
          isLoadingProduct: ContentActivitySelectors.IsLoadingProductSelector(store),
          isPreviousProductsRoute: ContentActivitySelectors.IsPreviousProductsRouteSelector(store),
          previousRoute: ContentActivitySelectors.PreviousRouteSelector(store),
          productId: ContentActivitySelectors.ProductIdRouteParamSelector(store),
          productLOBDeliveryCapabilityLoaded: MetadataCodeLoadedSelector(CODES.ProductLineOfBusinessDeliveryCapability, store),
          productFilterText: ContentActivitySelectors.ProductFilterTextSelector(store),
          productName: ContentActivitySelectors.ProductNameSelector(store),
          recordCount: ContentActivitySelectors.RecordCountSelector(store),
          routeParams: RouteParams(store),
          selectedActivity: ContentActivitySelectors.SelectedActivitySelector(store),
          selectedPageSizePreference: ContentActivitySelectors.SelectedPageSizePreference(store),
          selectedProduct: ContentActivitySelectors.SelectedProductSelector(store),
          shouldShowBackBanner: ContentActivitySelectors.ShouldShowBackBannerSelector(store),
          showListEmptyState: ContentActivitySelectors.ShowListEmptyStateSelector(store),
          showBackBanner: ContentActivitySelectors.ShowRouteBackBannerSelector(store),
          userPageSizePreference: PageSizePreferenceSelector(store)
        };
      };
      var controllerActions = {
        cancelContentActivity: ContentActivityActions.cancelContentActivity,
        fetchCustomerContentActivity: ContentActivityActions.fetchCustomerContentActivity,
        fetchProductLineOfBusinessDeliveryCapability: fetchProductLineOfBusinessDeliveryCapability,
        getProductMetadata: getProductMetadata,
        setActiveIsSelected: ContentActivityActions.setActiveIsSelected,
        setCurrentPage: ContentActivityActions.setCurrentPage,
        setPageSizePreference: ContentActivityActions.setPageSizePreference,
        setSelectedContentActivity: ContentActivityActions.setSelectedContentActivity,
        showBackBanner: ContentActivityActions.showBackBanner,
        stateGo: stateGo
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.productLOBDeliveryCapabilityLoaded) {
        this.actions.fetchProductLineOfBusinessDeliveryCapability();
      }
      if (!this.state.hasLoadedContentActivity) {
        this.retrieveCustomerContentActivity().then(function () {
          _this.setSelectedTabAndSetNotificationCount();
        });
      }
      if (!this.state.productId && !this.state.deviceId) {
        this.actions.stateGo('index.customercare.customer.contentActivity', null, {
          location: 'replace'
        });
      } else {
        this.actions.showBackBanner(true);
        if (this.state.productId) {
          this.actions.getProductMetadata(this.state.productId, this.state.currentCustomer.Language);
        }
        if (this.state.productId && this.state.routeParams && this.state.routeParams.lockerItemId) {
          this.ShowBackBanner = true;
          this.previousRoute = {
            name: PRODUCT_DETAILS_PAGE_REDIRECT,
            params: {
              lockerItemId: this.state.routeParams.lockerItemId
            }
          };
        }
      }
      this.stateOrName = this.state.productId || this.state.deviceId ? 'index.customercare.customer.contentActivity.product' : 'index.customercare.customer.contentActivity';
      this.optionalParams = {
        customerId: this.state.currentCustomerId,
        productId: this.state.productId,
        deviceId: this.state.deviceId
      };
      this.activityTabs = [{
        id: 0,
        glyph: ContentActivitySelectors.GLYPH.CLOCK_O,
        active: this.state.activeIsSelected,
        hasEmphasis: true,
        notificationCount: null,
        showActive: true
      }, {
        id: 1,
        glyph: ContentActivitySelectors.GLYPH.ARCHIVE,
        active: this.state.activeIsSelected,
        notificationCount: null,
        showActive: false
      }];
      this.removable = REMOVABLE;
      this.maximumPaginationSlots = PAGINATION_SLOTS;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }, {
    key: "cancelStream",
    value: function cancelStream(contentActivity) {
      var _this2 = this;
      var params = {
        Reference: contentActivity.Reference,
        PricingPlanId: contentActivity.PricingPlanId
      };
      this.actions.cancelContentActivity(this.state.currentCustomerId, params).then(function () {
        var localeKey = contentActivity.Download ? CustomerLocaleKeys.CONTENT_ACTIVITY.CANCEL_DOWNLOAD.TERMINATED : CustomerLocaleKeys.CONTENT_ACTIVITY.CANCEL_STREAM.TERMINATED;
        return Promise.all([_this2.retrieveCustomerContentActivity(), _this2.uiNotificationService.success(i18n.translate(localeKey), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        })]);
      }).then(function () {
        if (_this2.state.activeItemCount > 0) {
          _this2.actions.setSelectedContentActivity('1');
        }
      }).catch(function () {
        _this2.uiNotificationService.error(_this2.state.errorMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "setSelectedTabAndSetNotificationCount",
    value: function setSelectedTabAndSetNotificationCount() {
      this.actions.setActiveIsSelected(this.state.hasActiveContentActivity);
      this.setActiveTabAndNotificationCount();
    }
  }, {
    key: "setActiveTabAndNotificationCount",
    value: function setActiveTabAndNotificationCount() {
      var _this3 = this;
      this.activityTabs.forEach(function (tab) {
        tab.active = _this3.state.activeIsSelected === tab.showActive;
        if (tab.showActive) {
          tab.notificationCount = _this3.state.activeItemCount;
        }
      });
    }
  }, {
    key: "handleContentActivitySelected",
    value: function handleContentActivitySelected(contentActivity) {
      this.actions.getProductMetadata(contentActivity.ProductId, this.state.currentCustomer.Language);
      this.actions.setSelectedContentActivity(contentActivity.Id);
    }
  }, {
    key: "retrieveCustomerContentActivity",
    value: function retrieveCustomerContentActivity() {
      var _this4 = this;
      if (!this.state.selectedPageSizePreference) {
        this.actions.setPageSizePreference(this.state.userPageSizePreference);
      }
      var additionalParams = {
        PhysicalDeviceId: this.state.deviceId || undefined,
        ProductId: this.state.productId ? this.state.productId : undefined,
        PageNumber: this.state.currentPage,
        PageSize: this.state.selectedPageSizePreference
      };
      return this.actions.fetchCustomerContentActivity(this.state.currentCustomerId, additionalParams).then(function () {
        if (_this4.state.selectedActivity.ProductId) {
          _this4.actions.getProductMetadata(_this4.state.selectedActivity.ProductId, _this4.state.currentCustomer.Language);
        }
        _this4.setSelectedTabAndSetNotificationCount();
      });
    }
  }, {
    key: "removeRouteFilter",
    value: function removeRouteFilter() {
      this.actions.stateGo('index.customercare.customer.contentActivity', null, {
        reload: true
      });
    }
  }, {
    key: "setCurrentPage",
    value: function setCurrentPage(page) {
      this.actions.setCurrentPage(page);
      this.retrieveCustomerContentActivity();
    }
  }, {
    key: "onBannerClose",
    value: function onBannerClose() {
      this.actions.showBackBanner(false);
    }
  }, {
    key: "handleTabSelected",
    value: function handleTabSelected(tabSelected) {
      this.activityTabs.forEach(function (tab) {
        tab.active = tab.id === tabSelected.id;
      });
      this.actions.setActiveIsSelected(tabSelected.showActive);
      this.actions.setSelectedContentActivity(this.state.customerContentActivity.length ? this.state.customerContentActivity[0].Id : null);
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setPageSizePreference(pageSize);
      this.setCurrentPage(1);
    }
  }]);
}();
export default {
  controller: ContentActivityController,
  controllerAs: 'ContentActivityController',
  template: require('./content.activity.html')
};